import * as Lucide from "lucide-react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES_DETAILED } from "@/lib/data";

const ServicesDetailed = () => {
  return (
    <section className="py-24 lg:py-32 bg-white" data-testid="services-detailed-section">
      <div className="container-tm">
        <div className="max-w-3xl mb-20">
          <span className="overline">Nos prestations</span>
          <h2 className="mt-5 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Une prestation pensée
            <span className="italic text-gold"> de A à Z</span>.
          </h2>
          <p className="mt-6 font-sans text-base md:text-lg text-ink/65 leading-relaxed max-w-2xl">
            Voici en détail tout ce que nous prenons en charge pour vous décharger entièrement du pilotage de votre location courte durée.
          </p>
        </div>

        <div className="space-y-24 lg:space-y-32">
          {SERVICES_DETAILED.map((s, i) => {
            const Icon = Lucide[s.icon] || Lucide.Sparkles;
            const reversed = i % 2 === 1;
            return (
              <article
                key={s.title}
                data-testid={`service-detailed-${i}`}
                className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center"
              >
                <div className={`lg:col-span-6 ${reversed ? "lg:order-2" : ""}`}>
                  <div className="relative aspect-[4/3] lg:aspect-square rounded-3xl overflow-hidden shadow-lift bg-cream">
                    <img
                      src={s.image}
                      alt={s.alt}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                    <div className="absolute top-5 left-5 bg-white/95 backdrop-blur-sm rounded-full px-4 py-2 shadow-soft">
                      <span className="text-[10px] uppercase tracking-[0.25em] font-semibold text-gold">
                        Service · {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>
                  </div>
                </div>

                <div className={`lg:col-span-6 ${reversed ? "lg:order-1 lg:pr-10" : "lg:pl-10"}`}>
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-14 h-14 rounded-2xl bg-sage/10 flex items-center justify-center shrink-0">
                      <Icon size={26} strokeWidth={1.5} className="text-sage" />
                    </div>
                    <span className="number-circle">{String(i + 1).padStart(2, "0")}</span>
                  </div>

                  <h3 className="font-serif font-light text-ink text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
                    {s.title}
                  </h3>
                  <p className="mt-6 font-sans text-base md:text-lg text-ink/70 leading-relaxed">
                    {s.text}
                  </p>

                  <div className="mt-8 flex items-center gap-2 text-sage">
                    <div className="flex-1 h-px bg-gold/30" />
                    <span className="text-[10px] uppercase tracking-[0.25em] font-semibold">
                      Inclus dans la formule 15%
                    </span>
                  </div>
                  {s.note ? (
                    <p
                      className="mt-3 font-sans text-xs md:text-sm text-ink/55 italic leading-relaxed"
                      data-testid={`service-note-${i}`}
                    >
                      {s.note}
                    </p>
                  ) : null}
                </div>
              </article>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-24 lg:mt-32 bg-ink rounded-3xl p-10 md:p-14 lg:p-16 text-white grain-overlay relative overflow-hidden">
          <div className="absolute -top-20 -right-20 w-[400px] h-[400px] bg-gold/20 rounded-full blur-[120px] pointer-events-none" />
          <div className="relative grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <span className="overline text-gold">Prêt à déléguer ?</span>
              <h3 className="mt-4 font-serif font-light text-white text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
                Confiez-nous votre logement,
                <span className="italic text-gold"> on s'occupe du reste</span>.
              </h3>
            </div>
            <div className="flex flex-wrap gap-3 lg:justify-end">
              <Link
                to="/contact"
                state={{ scrollTo: "simulator" }}
                className="btn-accent group"
                data-testid="services-cta-estimate"
              >
                Calculez vos revenus
                <ArrowRight size={14} strokeWidth={2} className="ml-3 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link to="/contact" className="btn-secondary bg-transparent border-white/30 text-white hover:bg-white hover:text-ink" data-testid="services-cta-contact">
                Nous contacter
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesDetailed;
